import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Certifications from "./Certifications";
import PageSEO from "../../utils/PageSEO";
import { useTranslation } from "../../i18n";

function About() {
  const { t } = useTranslation();

  const aboutStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://yuvasree.online/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About",
        "item": "https://yuvasree.online/about"
      }
    ]
  };

  return (
    <>
      <PageSEO
        title="About Yuvasree Padmanabhan | Skills, Certifications & Experience"
        description="Learn about Yuvasree Padmanabhan's professional background, technical skills, certifications, and experience in automation testing and software development. Pursuing BE Computer Science at Meenakshi Sundararajan Engineering College."
        keywords="Yuvasree Padmanabhan about, software engineer skills, test automation, tech stack, programming skills, certifications, Java, JavaScript, React, Node.js, SQL"
        url="https://yuvasree.online/about"
        structuredData={aboutStructuredData}
      />
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              xs={12}
              md={7}
              className="about-text-col"
            >
              <h1 className="about-page-heading">
                {t("about.knowWho")}{" "}
                <strong className="purple">{t("about.knowWhoHighlight")}</strong>
              </h1>
              <Aboutcard />
            </Col>
            <Col xs={12} md={5} className="about-img">
              <img src={laptopImg} alt="about" className="img-fluid" />
            </Col>
          </Row>
          <h1 className="project-heading">
            {t("about.skillset")}{" "}
            <strong className="purple">{t("about.skillsetHighlight")} </strong>
          </h1>

          <Techstack />

          <h1 className="project-heading">
            <strong className="purple">{t("about.certifications")}</strong>
          </h1>
          <Certifications />
        </Container>
      </Container>
    </>
  );
}

export default About;
